import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from 'recharts'
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'

const DUMMY_DATA = [
  { name: 'Feb', value: 42000 },
  { name: 'Mar', value: 48500 },
  { name: 'Apr', value: 45200 },
  { name: 'May', value: 51000 },
  { name: 'Jun', value: 53800 },
  { name: 'Jul', value: 57200 },
]

export function MonthlyRevenueTrendWidget() {
  return (
    <Card className='h-full flex flex-col'>
      <CardHeader className='pb-2'>
        <CardTitle className='text-sm font-medium text-muted-foreground'>
          Monthly Revenue Trend
        </CardTitle>
      </CardHeader>
      <CardContent className='flex-1 min-h-0'>
        <ResponsiveContainer width='100%' height='100%'>
          <BarChart
            data={DUMMY_DATA}
            margin={{ top: 10, right: 10, left: -10, bottom: 0 }}
          >
            <CartesianGrid
              strokeDasharray='3 3'
              vertical={false}
              stroke='hsl(var(--border))'
            />
            <XAxis
              dataKey='name'
              axisLine={false}
              tickLine={false}
              tick={{ fontSize: 11, fill: 'hsl(var(--muted-foreground))' }}
            />
            <YAxis
              axisLine={false}
              tickLine={false}
              tick={{ fontSize: 11, fill: 'hsl(var(--muted-foreground))' }}
            />
            <Tooltip
              cursor={{ fill: 'hsl(var(--muted) / 0.5)' }}
              contentStyle={{
                borderRadius: '10px',
                border: '1px solid hsl(var(--border))',
                boxShadow: '0 4px 12px hsl(var(--foreground) / 0.08)',
                backgroundColor: 'hsl(var(--card))',
                fontSize: '12px',
              }}
            />
            <Bar dataKey='value' fill='#6366f1' radius={[6, 6, 0, 0]} />
          </BarChart>
        </ResponsiveContainer>
        <p className='text-xs text-muted-foreground mt-1'>
          Dummy data — live connection coming later
        </p>
      </CardContent>
    </Card>
  )
}
